import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const AddCandidatePage = React.lazy(() => import('modules/ats_hiring_tool/pages/AddCandidatePage'))
const RootPage = React.lazy(() => import('modules/ats_hiring_tool/pages/RootPage'))
const ShowApplicationAddedPage = React.lazy(
  () => import('modules/ats_hiring_tool/pages/ShowApplicationAddedPage')
)
const ShowCandidateAddedPage = React.lazy(
  () => import('modules/ats_hiring_tool/pages/ShowCandidateAddedPage')
)

export const atsHiringToolRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.hiringTool.path,
      element: <RootPage />,
      children: [
        {
          index: true,
          element: <AddCandidatePage />,
        },
        {
          path: navigation.hiringTool.candidateAdded.path,
          element: <ShowCandidateAddedPage />,
        },
        {
          path: navigation.hiringTool.applicationAdded.path,
          element: <ShowApplicationAddedPage />,
        },
      ],
    },
  ]
}
